import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ArrowBackIcon,
  Breadcrumbs,
  ColorBox,
  Grid,
  Link,
  PageHeader,
  Typography
} from '@esgian/esgianui';
import { getPortDetails } from '@api/Port';
import PortProfileSection from '@components/Sections/ShipAnalytics/PortProfileSection';

import { useSegment } from '@hooks';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

function PortProfilePage() {
  const params = useParams();
  const navigate = useNavigate();
  const { isRoRo } = useSegment();

  const routeChange = (path) => {
    navigate(path);
  };

  const portDetailsQuery = useQuery({
    queryKey: ['portDetails', params.portId],
    enabled: !!params.portId,
    placeholderData: null,
    queryFn: ({ signal, queryKey }) =>
      getPortDetails(signal, queryKey[1])
        .then((resp) => resp)
        .catch((error) => {
          if (error.name !== 'AbortError') {
            toast.error('Unable to fetch port details.', {
              position: 'top-right'
            });
          }
          return null;
        })
  });

  const { portName } = portDetailsQuery.data || {};
  return (
    <Grid item container spacing={2}>
      <Grid item>
        <ColorBox onClick={() => routeChange(-1)}>
          <ArrowBackIcon fontSize={'small'} />
        </ColorBox>
      </Grid>
      <Grid item>
        <PageHeader
          loading={portDetailsQuery.isFetching}
          title={`${portName}`}
          breadcrumbs={
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                color="inherit"
                sx={{ cursor: 'pointer' }}
                onClick={() =>
                  routeChange(isRoRo ? '/roro/commercial-analytics' : '/mpp/commercial-analytics')
                }>
                Home
              </Link>
              <Link
                sx={{ cursor: 'pointer' }}
                underline="hover"
                color="inherit"
                onClick={() =>
                  routeChange(isRoRo ? '/roro/commercial-analytics' : '/mpp/commercial-analytics')
                }>
                Commercial Analytics
              </Link>
              <Typography color="primary">Port Profile</Typography>
            </Breadcrumbs>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <PortProfileSection portDetailsQuery={portDetailsQuery} />
      </Grid>
    </Grid>
  );
}

PortProfilePage.propTypes = { portCongestionData: PropTypes.array };

PortProfilePage.defaultProps = { portCongestionData: [] };

export default PortProfilePage;
